import { useCreateExclusiveFilters } from '@/services/api/hooks/exclusiveFilters';
import { useCallback } from 'react';
import { ProcessedOrgTree } from '@/components/org/TenantRestrictionTree';

export const useSaveProductRestrictions = () => {
  const createFilter = useCreateExclusiveFilters();

  return useCallback(async (productId: string, orgTree: ProcessedOrgTree[]) => {
    const checkedMsps = orgTree.filter(msp => msp.checked);

    const checkedCustomers: string[] = [];

    orgTree.forEach(org =>
      org.customers.forEach(customer => {
        if (customer.checked) {
          checkedCustomers.push(customer.customerId);
        }
      })
    );

    await createFilter.mutateAsync({
      daasCatalogItemId: productId,
      partnerIds: checkedMsps.map(msp => msp.mspId),
      companyIds: checkedCustomers
    });
  }, []);
};
